import { render, staticRenderFns } from "./ResultadoPesquisa.vue?vue&type=template&id=275d26d4&scoped=true&lang=pug"
import script from "./ResultadoPesquisa.vue?vue&type=script&lang=js"
export * from "./ResultadoPesquisa.vue?vue&type=script&lang=js"
import style0 from "./ResultadoPesquisa.vue?vue&type=style&index=0&id=275d26d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275d26d4",
  null
  
)

export default component.exports